import React from "react";
import { Chat, Phone, Email } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import Configs from "../../Assets/editable-stuff/configurations.json";

const ITServicesGrid = () => {
  const services = [
    {
      id: "VirusRemoval",
      icon: require("../../Assets/img/IT Page/virusLogo.png"),
      title: "Virus Removal",
      description: "Malicious software and viruses are impacting your computer's performance. Our Geeks will remove any malware or virus affecting your system.",
      template: Configs.virusTemplate,
      subject: Configs.virusSubject,
      color: "#ff6b6b"
    },
    {
      id: "WIFIOPTIMIZATION",
      icon: require("../../Assets/img/IT Page/wifiLogo.png"),
      title: "WiFi Optimization",
      description: "Slow Internet? Can't get a page to load? We'll make your wireless internet better than ever with full optimization.",
      template: Configs.wifiTemplate,
      subject: Configs.wifiSubject,
      color: "#4ecdc4"
    },
    {
      id: "SYSTEMUPGRADES",
      icon: require("../../Assets/img/IT Page/toolsLogo.png"),
      title: "System Upgrades",
      description: "Increase performance with additional memory or a solid state upgrade. We can revive desktops, laptops and servers of all brands.",
      template: Configs.systemTemplate,
      subject: Configs.systemSubject,
      color: "#45b7d1"
    },
    {
      id: "CLOUDMIGRATION",
      icon: require("../../Assets/img/IT Page/cloudLogo.png"),
      title: "Cloud Migration",
      description: "We can reliably float your files, e-mails, contacts, calendars over to remote servers so you never have to worry again.",
      template: Configs.cloudTemplate,
      subject: Configs.cloudSubject,
      color: "#96ceb4"
    }
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        <div className="section-header">
          <span className="section-label">Our Services</span>
          <h2 className="section-title">What We Can Do For You</h2>
          <p className="section-subtitle">
            Professional IT services to keep your technology running smoothly
          </p>
        </div>

        <div className="services-grid-modern">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="service-card-modern"
              style={{ '--accent-color': service.color }}
            >
              <div className="service-card-header">
                <div className="service-icon-wrapper">
                  <img src={service.icon} alt={service.title} />
                </div>
                <span className="service-number">0{index + 1}</span>
              </div>

              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>

              <div className="service-actions">
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Phone />}
                  href={"tel: " + Configs.PhoneNumber}
                >
                  Call
                </Button>
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Chat />}
                  href={"sms: " + Configs.PhoneNumber + "&body=" + service.template}
                >
                  Text
                </Button>
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Email />}
                  href={"mailto: " + Configs.EmailAddress + "?subject=" + service.subject + "&body=" + service.template}
                >
                  Email
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="cta-banner">
          <div className="cta-content">
            <h3>Need help with something else?</h3>
            <p>We offer a wide range of IT services. Get in touch to discuss your needs.</p>
          </div>
          <div className="cta-actions">
            <Button
              className="cta-btn-primary"
              variant="contained"
              startIcon={<Phone />}
              href={"tel: " + Configs.PhoneNumber}
            >
              Call (929) 330-4724
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ITServicesGrid;
